import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { queryClient } from "./config/queryClient";
import AppErrorBoundary from "./features/shared/components/AppErrorBoundary";
import "./features/shared/styles/index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    {/* Por fuera de todo: si falla el theme, el router o una pantalla, queda un
        cartel con el botón de recargar en lugar de la pantalla en blanco. */}
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
